import classNames from "classnames";
import React, { PropsWithChildren } from "react";

export interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const Modal = ({ children, isOpen, onClose }: ModalProps & PropsWithChildren) => (
  <div
    aria-hidden={!isOpen}
    className={classNames(
      "fixed inset-0 bg-form-section-border z-modal transition-opacity duration-200",
      "flex items-center justify-center p-4 lg:py-14",
      isOpen ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"
    )}
    onClick={() => onClose()}
  >
    <div
      className={classNames(
        "px-8 py-10 lg:p-20 bg-form-bg rounded-2xl shadow-modal",
        "max-w-4xl max-h-full overflow-y-auto"
      )}
      onClick={e => e.stopPropagation()}
    >
      {children}
    </div>
  </div>
);
